export const updateName = (name) => (dispatch) => {
  dispatch({
    type: 'UPDATE_ACTIVITIES_CHECKIN_NAME',
    payload: name
  });
};

export const updateSelected = (id) => (dispatch, getState) => {
  dispatch({
    type: 'UPDATE_ACTIVITIES_CHECKIN_SELECTED',
    payload: getState().activities.checkin.selected === id ? 0 : id
  });
};

export const clearSelection = () => (dispatch) => {
  dispatch({
    type: 'CLEAR_ACTIVITIES_CHECKIN_SELECTED'
  });
};
